import { Instagram, Facebook, Youtube } from 'lucide-react';
import { CONTACT, NAV_LINKS, ASSETS } from '@/data/content';
import { scrollToHash } from '@/lib/motion';

const SOCIALS = [
  { label: 'Instagram', href: CONTACT.instagram, icon: Instagram, testId: 'social-instagram' },
  { label: 'Facebook', href: CONTACT.instagram, icon: Facebook, testId: 'social-facebook' },
  { label: 'TikTok', href: CONTACT.instagram, icon: null, testId: 'social-tiktok' },
  { label: 'YouTube', href: CONTACT.instagram, icon: Youtube, testId: 'social-youtube' },
];

export default function Footer() {
  return (
    <footer className="relative bg-black border-t border-white/10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-20">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-3">
              <img src={ASSETS.logo} alt="ASA crest" className="h-14 w-14 rounded-full object-cover ring-1 ring-brand-gold/50" />
              <div className="leading-none">
                <div className="font-display text-2xl tracking-wide text-white">ABUZAMA</div>
                <div className="text-[10px] tracking-[0.32em] text-brand-gold font-semibold mt-1">SOCCER ACADEMY</div>
              </div>
            </div>
            <p className="mt-6 text-sm text-gray-400 leading-relaxed max-w-xs">
              “Developing Players. Building Champions. Inspiring Leaders.”
            </p>
            <p className="mt-3 text-xs text-gray-600 leading-relaxed max-w-xs">
              Premium youth soccer development for boys and girls ages 5–16 in Canton, Michigan.
            </p>
          </div>

          <nav data-testid="footer-nav">
            <div className="text-xs uppercase tracking-[0.3em] text-brand-gold font-semibold mb-5">Academy</div>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-3">
              {NAV_LINKS.map(l => (
                <li key={l.hash}>
                  <button onClick={() => scrollToHash(l.hash)} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-sm text-gray-400 hover:text-brand-gold transition-colors duration-300">
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-brand-gold font-semibold mb-5">Contact</div>
            <ul className="space-y-2.5 text-sm text-gray-400">
              <li>Canton, Michigan</li>
              <li><a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" className="hover:text-brand-gold transition-colors" data-testid="footer-phone">{CONTACT.phoneDisplay}</a></li>
              <li><a href={`mailto:${CONTACT.email}`} className="hover:text-brand-gold transition-colors break-all" data-testid="footer-email">{CONTACT.email}</a></li>
            </ul>
            <div className="mt-6 flex gap-3" data-testid="footer-socials">
              {SOCIALS.map(s => (
                <a key={s.label} href={s.href} target="_blank" rel="noreferrer" aria-label={s.label} data-testid={s.testId}
                  className="w-10 h-10 rounded-sm border border-white/15 flex items-center justify-center text-gray-400 hover:text-brand-gold hover:border-brand-gold/60 transition-colors duration-300">
                  {s.icon ? <s.icon size={17} /> : <span className="text-[11px] font-black">TT</span>}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-600">© 2026 Abu Zama Soccer Academy. All Rights Reserved.</p>
          <div className="flex items-center gap-5">
            <a href="/admin" className="text-xs text-gray-700 hover:text-brand-gold transition-colors" data-testid="footer-admin-link">Admin</a>
            <p className="font-display tracking-[0.3em] text-sm text-brand-gold uppercase" data-testid="footer-tagline">Built for Champions.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
